// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2hbQ0","col":"styles_col__eEHjd","fulfillmentStatus":"styles_fulfillmentStatus__1iBqQ","emailCol":"styles_emailCol__3uKJC"};